import { createSlice } from "@reduxjs/toolkit";

import { IRecipeStore } from "../types";

const initialState: IRecipeStore = {
  recipes: [],
};

export const recipeSlice = createSlice({
  name: "recipe",
  initialState,
  reducers: {
    setRecipes: (state, { payload }) => {
      state.recipes = payload;
    },
  },
});

export const { setRecipes } = recipeSlice.actions;
